<template>
  <div>
    <basic-container>
      <div>
        <el-form ref="form" :model="customerForm">

          <el-form-item label="客户姓名" label-width="100px">

            <div style="display: flex;width:300px;">
              <el-input v-model="customerForm.name" placeholder='请输入客户姓名'></el-input>
            </div>
          </el-form-item>

          <el-form-item label="客户电话" label-width="100px">

            <div style="display: flex;width:300px;">
              <el-input v-model="customerForm.mobile" placeholder='请输入客户电话'></el-input>
            </div>
          </el-form-item>

          <el-form-item label="客户地址" label-width="100px">

            <div style="display: flex;width:300px;">
              <avue-map v-model="point"></avue-map>
              <el-input type="input" name="title" v-model="point.address"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="服务预约配置">
            <el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">

              <el-table-column prop="clientType" align="center" label="工程服务项目">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.serviceCategory" placeholder="请选择" required
                    @change="choseWorkServiceItem" value-key="id">
                    <el-option v-for="serviceCategory in serviceCategorys" :key="serviceCategory.id"
                      :label="serviceCategory.name" :value="serviceCategory"></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column align="center" label="操作" width="120">
                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-close" size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column align="center" label="配置" width="150">
                <template slot-scope="scope">
                  <el-button type="success" icon="el-icon-plus" size="small"
                    @click="handleAddRows(scope.$index, scope.row)">增加一行</el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <el-button type="success" icon="el-icon-plus" size="small" style="margin: 20px 0"
                  @click="handleAddRows()">增加一行</el-button>
              </template>
            </el-table>
          </el-form-item>
          <el-form-item label="动态参数配置">
            <el-table :data="tableData1" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">

              <el-table-column prop="parameterName" label="显示名称">
                <template slot-scope="scope">
                  <el-input type="input" name="parameterName" v-model="scope.row.parameterName"
                    :value="scope.row.parameterName" placeholder="请输入名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="currControlType" min-width="150" label="控件类型">
                <template slot-scope="scope">
                  <div>
                    <div v-if='scope.row.isMessageReminder == "YES"'>
                      <el-select name="currControlType" v-model="scope.row.currControlType" placeholder="请选择控件类型"
                        clearable value-key="value" disabled>
                        <el-option v-for="item in currControlTypes" :key="item.value" :label="item.label" :value="item">
                        </el-option>
                      </el-select>
                    </div>
                    <div v-else>
                      <el-select name="currControlType" v-model="scope.row.currControlType" placeholder="请选择控件类型"
                        clearable @change="changeInputType(scope.row.currControlType, scope)" value-key="value">
                        <el-option v-for="item in currControlTypes" :key="item.value" :label="item.label" :value="item">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="datas" min-width="150" label="参数数据">
                <template slot-scope="scope">
                  <el-input type="textarea" name="datas"
                    v-if="scope.row.currControlType.value == 'RADIO' || scope.row.currControlType.value == 'CHECKBOX'"
                    v-model="scope.row.datas" :value="scope.row.datas" @blur="blurDataSource(scope)"
                    placeholder="请换行输入参数数据"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="dynamic" min-width="250" label="动态控件">
                <template slot-scope="scope">
                  <div>
                    <!-- datas -->
                    <div v-if='scope.row.currControlType.value == "RADIO"'>

                      <div v-for="(item, index) in scope.row.dynamicList" :key='index'>

                        <el-radio v-model="scope.row.isRadio" :label="item">
                        </el-radio>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value == "CHECKBOX"'>
                      <div>
                        <!-- v-for="(item,index) in scope.row.dynamicList"
                        :key='index' -->
                        <el-checkbox-group v-model="scope.row.dynamicCheckList">
                          <el-checkbox v-for="(item, index) in scope.row.dynamicList" :label="item"
                            :key='index'></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value == "INT_INPUT"'>
                      {{ scope.row.message }}
                      <div>
                        <!-- v-for="(item,index) in scope.row.dynamicList"
                        :key='index' -->
                        <el-input type="text" name="intInput" onkeyup="value=value.replace(/\D/g,'')"
                          v-model="scope.row.intInput" :value="scope.row.intInput"></el-input>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value == "FLOAT_INPUT"'>
                      <div>
                        <!-- v-for="(item,index) in scope.row.dynamicList"
                        :key='index' -->
                        <el-input type="text" name="floatInput"
                          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                          v-model="scope.row.floatInput" :value="scope.row.floatInput"></el-input>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value == "INPUT"'>
                      <div>
                        <!-- v-for="(item,index) in scope.row.dynamicList"
                        :key='index' -->
                        <el-input type="text" name="input" v-model="scope.row.input"
                          :value="scope.row.input"></el-input>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value == "TIME"'>
                      <div>
                        <!-- v-for="(item,index) in scope.row.dynamicList"
                        :key='index' -->
                        <el-time-picker v-model="scope.row.timeDate" placeholder="选择时间" value-format="timestamp">
                        </el-time-picker>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value == "DATE"'>
                      <div>
                        <!-- v-for="(item,index) in scope.row.dynamicList"
                        :key='index' -->
                        <el-date-picker v-model="scope.row.dateDate" type="date" placeholder="选择日期"
                          value-format="timestamp">
                        </el-date-picker>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value == "DATE_TIME"'>
                      <div>
                        <!-- v-for="(item,index) in scope.row.dynamicList"
                        :key='index' -->
                        <el-date-picker v-model="scope.row.dateTimeDate" type="datetime" placeholder="选择日期时间"
                          value-format="timestamp">
                        </el-date-picker>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value == "ADDRESS"'>
                      <div style="display: flex;width:300px;">
                        <avue-map v-model="scope.row.point"></avue-map>
                        <el-input type="input" name="title" v-model="scope.row.point.address"></el-input>
                      </div>
                    </div>
                    <div>
                      <div>
                        <el-select v-model="scope.row.selectEngineer" placeholder="请选择服务人员" filterable
                          v-if='scope.row.currControlType.value == "SELECT_ENGINEER"' value-key="id">
                          <el-option v-for="item2 in scope.row.selectEngineerList" :key="item2.id"
                            :label="item2.realName" :value="item2"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div>
                      <div>
                        <el-select v-model="scope.row.multipleSelectEngineer" placeholder="请选择服务人员"
                          v-if='scope.row.currControlType.value == "MULTIPLE_SELECT_ENGINEER"' filterable multiple
                          value-key="id">
                          <el-option v-for="item2 in scope.row.multipleSelectEngineerList" :key="item2.id"
                            :label="item2.realName" :value="item2"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value == "PICTURE"'>
                      <div>
                        <el-dialog :visible.sync="dialogVisible">
                          <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                        <el-upload class="upload-demo" action="#" accept=".jpg, .jpeg,.png" :on-remove="handleRemove"
                          :multiple="true" :http-request="fnUploadDescribeImgs" list-type="picture-card"
                          :on-preview="handlePreview" :on-exceed="handleExceed" :file-list="scope.row.fileList">
                          <el-button size="small" type="primary"
                            @click="isIndex(scope.row, scope.$index)">点击上传</el-button>
                          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="isMessageReminder" label="是否消息提醒" width="150">
                <template slot-scope="scope">
                  <el-radio v-model="scope.row.isMessageReminder" label="YES" @change="changeIsReminder(scope)">
                    是
                  </el-radio>
                  <el-radio v-model="scope.row.isMessageReminder" label="NO" @change="changeIsReminder(scope)">
                    否
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="120">

                <template slot-scope="scope">
                  <el-button type="danger" icon="el-icon-close" size="small"
                    @click="handleStepping1Delete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column align="center" label="配置" width="150">
                <template slot-scope="scope">
                  <el-button type="success" icon="el-icon-plus" size="small"
                    @click="handleAdd1Rows(scope.$index, scope.row)">增加一行</el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <el-button type="success" icon="el-icon-plus" size="small" style="margin: 20px 0"
                  @click="handleAdd1Rows()">增加一行</el-button>
              </template>
            </el-table>
          </el-form-item>
        </el-form>
        <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
          <el-button type="primary" size="big" @click="submit">确定新增</el-button>
        </div>
      </div>

    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import {
  findAllSuperiorDepartment,
  addProject,
  findProvince,
  findCitys,
  findAreas,
  findDataSourceFields,
  findDataSourceAll,
  getDynamicParamConfig,
  addCustomerInfo,
  findUsersList,
  findUsersAll
} from "@/api/salesCloud/customerInfo";
import { findUserList } from "@/api/salesCloud/bindEngineer";
import {
  findCategoryAll,
  findItemsByCategory
} from "@/api/salesCloud/workOrder";
export default {
  data() {
    return {
      customerForm: {},
      isTop: "YES",
      point: {},
      currIndex: {},
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      currservicePeoples: [],
      currControlTypes: DIC.CONTROL_TYPE,
      clientTypes: DIC.SERVICEITEM_TYPE,
      payers: DIC.SERVICEITEM_PAYER,
      auditors: DIC.SERVICEITEM_PAYER,
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      serviceItem: {},
      areas: [],
      citys: [],
      provinces: [],
      tableData: [],
      tableData1: []
    };
  },
  created() {
    // let params = {};
    // params.userType = "JOINS_ENGINEER";
    // findUsersAll(params).then(res => {
    //   // console.log(res);
    //   let data = JSON.parse(res.data);
    //   this.currservicePeoples = data.rows;
    // });
    findCategoryAll().then(res => {
      // console.log(res);
      let data = JSON.parse(res.data);
      this.serviceCategorys = data;
    });
    this.getDynamicParamConfig();
  },
  methods: {
    /**
     * @description 动态参数配置回显
     */
    async getDynamicParamConfig() {
      let params = {};
      params.categoryId = this.serviceCategory.id;
      params.itemId = this.serviceItem.id;
      let res = await getDynamicParamConfig().then(res => {
        return JSON.parse(res.data);
      });
      // console.log(res);
      let data = res;
      let tableData1 = [];
      //动态参数配置回显
      for (let i of data) {
        let obj = {};
        obj.parameterName = i.parameterName;
        obj.currControlType = {};
        obj.dynamicList = [];//参数数据列表
        obj.dynamicCheckList = []; //多选
        obj.selectEngineer = {};
        obj.multipleSelectEngineer = [];
        obj.point = {};
        obj.multipleSelectEngineerList = [];
        obj.selectEngineerList = [];
        obj.isMessageReminder = "NO";
        obj.fileList = [];
        obj.currControlType.value = i.controlType;
        if (i.controlType == "RADIO") {
          obj.datas = i.dataSource;
          obj.dynamicList = i.dataSource.split(/[(\r\n)\r\n]+/);
          obj.dataSourceList = i.dataSource.split(/[(\r\n)\r\n]+/);
        }
        if (i.controlType == "CHECKBOX") {
          obj.datas = i.dataSource;
          obj.dataSourceList = i.dataSource.split(/[(\r\n)\r\n]+/);
          obj.dynamicCheckList = i.dynamicCheckList.split(","); //多选
        }
        tableData1.push(obj);
      }
      this.tableData1 = tableData1;
    },
    remoteMethod(query) {
      // console.log(query);
      if (/^[\u4e00-\u9fa5]+$/i.test(query) && query.length < 5) {
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            // console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.currservicePeoples = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        }, 200);
      }
      else if (query.length == 5) {
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            // console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.currservicePeoples = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        }, 200);
      } else if (query.length == 11) {
        // this.loading = true;
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            // console.log(res);
            let data = JSON.parse(res.data);
            this.currservicePeoples = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    blurDataSource(scope) {
      // console.log(scope.row.datas.split(/[(\r\n)\r\n]+/));
      if (scope.row.datas) {
        scope.row.dynamicList = scope.row.datas.split(/[(\r\n)\r\n]+/);
      }
    },
    changeIsReminder(scope) {
      if (scope.row.isMessageReminder == "YES") {
        scope.row.message = "单位：月";
      } else {
        scope.row.message = "";
      }
      scope.row.currControlType = {};
      scope.row.currControlType.value = "INT_INPUT";
      scope.row.currControlType.label = "整数输入文本框";
    },
    changeInputType(type, scope) {
      // console.log(type, scope);
      if (type.value == "SELECT_ENGINEER") {
        let params = {};
        params.userType = "JOINS_ENGINEER";
        findUsersAll(params).then(res => {
          // console.log(scope.row);
          let data = JSON.parse(res.data);
          scope.row.selectEngineerList = data.rows;
        });
      }
      if (type.value == "MULTIPLE_SELECT_ENGINEER") {
        // scope.row.multipleSelectEngineer = [];
        let params = {};
        params.userType = "JOINS_ENGINEER";
        findUsersAll(params).then(res => {
          // console.log(scope.row);
          let data = JSON.parse(res.data);
          scope.row.multipleSelectEngineerList = data.rows;
        });
      }
    },
    choseServiceItem(e) {
      // console.log(e);
    },
    choseWorkServiceItem(e) {
      console.log(e);
      /* findItemsByCategory(e.id).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
        // console.log(data);
      });
      this.serviceItem = ""; */
    },
    chooseProvince(e, scope) {
      // console.log(e);
      // console.log(scope);
      findCitys(e.id).then(res => {
        this.citys = res.data;
        scope.row.currentCity = "";
        this.currentArea = "";
      });
    },
    chooseCity(e, scope) {
      // console.log(e);
      // console.log(scope);
      findAreas(e.id).then(res => {
        this.areas = res.data;
        this.currentArea = "";
      });
    },
    chooseArea(e) {
      // console.log(e);
    },
    submit() {
      let params = {};
      params = this.customerForm;
      if (this.point.location) {
        params.longitude = this.point.location.lng;
        params.latitude = this.point.location.lat;
        params.province = this.point.pcode;
        params.city = this.point.adcode.substring(0, 4) + "00";
        params.area = this.point.adcode;
        params.provinceName = this.point.pname;
        params.cityName = this.point.cityname;
        params.areaName = this.point.adname;
        params.address = this.point.address;
      }
      let services = [];
      services = this.tableData;
      for (let item of services) {
        if (item.serviceCategory) {
          item.serviceStatus = item.serviceCategory.id;
        }
        /* let currservicePeople = item.currservicePeople;
        item.servicePeople = currservicePeople.join(","); */
      }
      if (services.length > 0) {
        params.services = services;
      }
      let vices = [];
      vices = this.tableData1;

      for (let item of vices) {
        // console.log(item);
        item.data = {};
        item.dataSource = item.datas;
        let currControlType = item.currControlType.value;
        item.controlType = currControlType;
        if (item.controlType == "INT_INPUT") {
          item.data.intInput = item.intInput; //整数输入文本框
        }
        if (item.controlType == "FLOAT_INPUT") {
          item.data.floatInput = item.floatInput; //小数输入文本框
        }
        if (item.controlType == "INPUT") {
          item.data.input = item.input; //输入文本框
        }
        if (item.controlType == "PICTURE") {
          // item.data.fileList = item.fileList; //图片
          item.data.fileList = item.image; //图片
          let fileName = [];
          for (let i of item.fileList) {
            fileName.push(i.name);
          }
          item.data.fileName = fileName.join(",");
        }
        if (item.controlType == "TIME") {
          item.data.timeDate = item.timeDate; //选择时间
        }
        if (item.controlType == "DATE") {
          item.data.dateDate = item.dateDate; //选择日期
        }
        if (item.controlType == "DATE_TIME") {
          item.data.dateTimeDate = item.dateTimeDate; //选择日期和时间
        }
        if (item.controlType == "RADIO") {
          item.data.isRadio = item.isRadio; //单选
        }
        if (item.controlType == "CHECKBOX") {
          item.data.dynamicCheckList = item.dynamicCheckList.join(","); //多选
        }
        if (item.controlType == "SELECT_ENGINEER") {
          item.data.selectEngineer = item.selectEngineer.id; //单选服务工程师
        }
        if (item.controlType == "MULTIPLE_SELECT_ENGINEER") {
          let arr = [];
          for (let j of item.multipleSelectEngineer) {
            arr.push(j.id);
          }
          item.data.multipleSelectEngineer = arr.join(","); //多选服务工程师
        }
        if (item.controlType == "ADDRESS") {
          if (item.point) {
            item.data.longitude = item.point.location.lng;
            item.data.latitude = item.point.location.lat;
            item.data.province = item.point.pcode;
            item.data.city = item.point.adcode.substring(0, 4) + "00";
            item.data.area = item.point.adcode;
            item.data.provinceName = item.point.pname;
            item.data.cityName = item.point.cityname;
            item.data.areaName = item.point.adname;
            item.data.address = item.point.address;
          }
        }
      }
      if (vices.length > 0) {
        // console.log(vices);
        params.vices = vices;
      }
      let item = {
        label: "新增客户信息",
        value: "/salesCloud/customerInfo/add"
      };
      // 表单验证
      if(params.name == undefined || params.name == ''){
        this.$message({
          showClose: true,
          message: "客户姓名不能为空",
          type: "error"
        });
        return;
      }
      if(params.mobile == undefined || params.mobile == ''){
        this.$message({
          showClose: true,
          message: "客户电话不能为空",
          type: "error"
        });
        return;
      }
      if(params.address == undefined || params.address == ''){
        this.$message({
          showClose: true,
          message: "客户地址不能为空",
          type: "error"
        });
        return;
      }
     addCustomerInfo(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/salesCloud/customerInfo",
              label: "客户信息管理"
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData.splice(index, 1);
    },
    handleStepping1Delete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData1.splice(index, 1);
    },
    handleAddRows(index, row) {
      let list = {};
      this.tableData.push(list);
    },
    handleAdd1Rows(index, row) {
      // console.log(this);
      // console.log(this.tableData1);
      let list = {
        currControlType: {},
        dynamicList: [], //参数数据列表
        dynamicCheckList: [], //多选
        selectEngineer: {},
        multipleSelectEngineer: [],
        point: {},
        multipleSelectEngineerList: [],
        selectEngineerList: [],
        isMessageReminder: "NO",
        fileList: []
      };
      this.tableData1.push(list);
    },

    handleRemove(file, fileList) {
      // console.log(this);
      // console.log(file, fileList);
      for (let item of this.tableData1) {
        for (let i of item.fileList) {
          // console.log(i);
          if (i.uid == file.uid) {
            // console.log(item);
            item.fileList = fileList;
          }
        }
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    isIndex(row, index) {
      // console.log(row, index);
      this.currIndex.index = index;
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      // console.log(option);
      var obj = {};
      obj.name = option.file.name;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            // console.log(results);
            // console.log(this.tableData1);
            // console.log(this.currIndex);
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            // this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            obj.url = array[0];
            // console.log(this.tableData1[this.currIndex.index]);
            this.tableData1[this.currIndex.index].fileList.push(obj);
            //上传多张图片
            if (this.tableData1[this.currIndex.index].image == undefined) {
              this.tableData1[this.currIndex.index].image = array[0];
            } else {
              let aa = "";
              this.tableData1[this.currIndex.index].image = aa.concat(
                this.tableData1[this.currIndex.index].image,
                ",",
                array[0]
              );
              // console.log(this.tableData1[this.currIndex.index].image);
            }
            // 上传单张图片
            // this.tableData1[this.currIndex.index][0].projectGuaranteeList[
            //   this.currIndex.idx
            // ].image = array[0];
            // console.log(obj);
            // this.fileList.push(obj);
            this.tableLoading = false;
          })
          .catch(err => {
            // console.log(err);
          });
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};
</script>

<style></style>